import { render, staticRenderFns } from "./DownloadDocumentBtn.vue?vue&type=template&id=959ce156&scoped=true&"
import script from "./DownloadDocumentBtn.vue?vue&type=script&lang=js&"
export * from "./DownloadDocumentBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "959ce156",
  null
  
)

export default component.exports